import { motion } from "framer-motion";
import { StoreCta } from "./StoreCta";
import { Leaderboard } from "./Leaderboard";
import { LeadCapture } from "./LeadCapture";
import { HeroVisual } from "./HeroVisual";

const MaskedLine = ({ children, delay }) => (
  <span className="block overflow-hidden pb-1">
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Hero = () => (
  <section id="top" className="hero-glow relative overflow-hidden">
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-16 px-6 pb-24 pt-36 md:px-12 lg:grid-cols-12 lg:pb-32 lg:pt-44">
      <div className="lg:col-span-7">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mb-8 inline-flex items-center gap-3 rounded-full border border-forest/10 bg-white px-4 py-2"
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-fresh opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-fresh" />
          </span>
          <span className="font-manrope text-xs font-bold uppercase tracking-[0.2em] text-forest">
            Now delivering across Calgary
          </span>
        </motion.div>

        <h1
          data-testid="hero-headline"
          className="font-syne text-[clamp(3rem,7.5vw,6.5rem)] font-extrabold leading-[0.95] tracking-tighter text-forest"
        >
          <MaskedLine delay={0.25}>Groceries in</MaskedLine>
          <MaskedLine delay={0.4}>
            <span className="text-fresh">20 Minutes.</span>
          </MaskedLine>
          <MaskedLine delay={0.55}>
            <span className="text-outline-dark">Not Hours.</span>
          </MaskedLine>
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.75 }}
          className="mt-8 max-w-xl text-base leading-relaxed text-forest/70 md:text-lg"
        >
          Freshly is changing the game in Calgary. While other apps take hours,
          our team of dedicated pickers and drivers work in perfect sync to get
          your order to your door in as little as 20 minutes.
        </motion.p>

        <LeadCapture />

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.05 }}
          className="mt-6 flex flex-wrap items-center gap-3"
        >
          <StoreCta />
        </motion.div>
        <Leaderboard />
      </div>

      <HeroVisual />
    </div>
  </section>
);
